import React, { useEffect, useState } from 'react';
import { portalApi, formatApiError } from '../../services/api';
import { Timer, Car } from '@phosphor-icons/react';
import { toast } from 'sonner';

const fmtEUR = (v) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(v || 0));
const STATUS = {
  draft: { label: 'Entwurf', color: 'bg-[#F5F7FA] text-[#525866]' },
  active: { label: 'Aktiv', color: 'bg-emerald-100 text-emerald-700' },
  terminated: { label: 'Beendet', color: 'bg-red-100 text-red-700' },
  expired: { label: 'Abgelaufen', color: 'bg-amber-100 text-amber-700' },
};

export default function PortalLongTerm() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await portalApi.longTerm();
        setItems(r.data || []);
      } catch (err) { toast.error(formatApiError(err)); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="p-6 space-y-6" data-testid="portal-longterm-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-[#111418]">Langzeitmiete</h1>
        <p className="text-[#525866] mt-1">Ihre Langzeitmietverträge</p>
      </div>

      {loading ? (
        <div className="card-swiss h-24 skeleton" />
      ) : items.length === 0 ? (
        <div className="card-swiss p-12 text-center">
          <Timer weight="thin" size={64} className="mx-auto text-[#8A94A6] mb-4" />
          <p className="text-[#525866]">Sie haben aktuell keine Langzeitmietverträge.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {items.map((c) => {
            const s = STATUS[c.status] || STATUS.draft;
            return (
              <div key={c.id} className="card-swiss p-5" data-testid={`portal-lt-card-${c.id}`}>
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <p className="font-bold text-[#111418] text-lg">{c.contract_number}</p>
                    <p className="text-sm text-[#525866]">{c.start_date} → {c.end_date || 'unbefristet'}</p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded font-semibold ${s.color}`}>{s.label}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-[#525866] mb-3">
                  <Car weight="bold" size={16} /> {c.vehicle?.brand} {c.vehicle?.model} · {c.vehicle?.license_plate}
                </div>
                {c.price_model === 'monthly_flat_km' ? (
                  <div className="flex justify-between items-baseline pt-3 border-t border-[#E2E4E9]">
                    <span className="text-sm text-[#525866]">Monatsrate</span>
                    <span className="font-bold text-[#111418] text-xl">{fmtEUR(c.monthly_rate)}</span>
                  </div>
                ) : (
                  <div className="flex justify-between items-baseline pt-3 border-t border-[#E2E4E9]">
                    <span className="text-sm text-[#525866]">Tagessatz</span>
                    <span className="font-bold text-[#111418] text-xl">{fmtEUR(c.daily_rate)}</span>
                  </div>
                )}
                {c.included_km_per_month > 0 && (
                  <p className="text-xs text-[#8A94A6] mt-1">Inkl. {c.included_km_per_month.toLocaleString('de-DE')} km / Monat</p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
